import { withStyles } from '@mui/styles';

import AssetList from './assetList';
import muiStyles from './styles';

export default withStyles(muiStyles)(AssetList);